import {BaseModel} from '../../base/models/base-model.model';

export class MenuItemModel extends BaseModel {

  constructor(
    public label: string,
    public routerLink: any[],
    public routerLinkActive: string,
    public data?: any,
    public icon?: string,
    public children?: MenuSubItemModel[],
    public disabled?: boolean,
    public visible?: boolean,
    public link?: string,
    public external?: boolean
  ) {
    super();
  }
}

export class MenuSubItemModel extends BaseModel {

  constructor(
    public label: string,
    public routerLink: Array<any>,
    public routerLinkActive: string,
    public data?: any,
    public disabled?: boolean,
    public icon?: string,
    public external?: boolean
  ) {
    super();
  }

  get id(): string {
    return this.label.split(' ').join('').split('/').join('');
  }
}
